var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoleTabActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user (23) 1",
    clipPath: "url(#clip0_9477_164095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.5417 13.763H18.3333V12.513C18.3333 11.3647 17.3984 10.4297 16.25 10.4297C15.1016 10.4297 14.1667 11.3647 14.1667 12.513V13.763H13.9583C13.1541 13.763 12.5 14.4171 12.5 15.2214V18.138C12.5 18.9423 13.1541 19.5964 13.9583 19.5964H18.5417C19.3459 19.5964 20 18.9423 20 18.138V15.2214C20 14.4171 19.3459 13.763 18.5417 13.763ZM15.4167 12.513C15.4167 12.0538 15.7909 11.6797 16.25 11.6797C16.7091 11.6797 17.0833 12.0538 17.0833 12.513V13.763H15.4167V12.513Z",
    fill: "#0C66E4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.25 15.2214C11.25 14.0964 11.9392 13.1305 12.9167 12.7214V12.513C12.9167 12.0064 13.0391 11.5314 13.2425 11.1005C12.6125 10.6779 11.8558 10.4297 11.0417 10.4297H3.95828C1.77582 10.4297 0 12.2055 0 14.388V17.3047C0 17.6497 0.279999 17.9297 0.625 17.9297H11.25V15.2214Z",
    fill: "#0C66E4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.6664 4.59641C11.6664 6.89758 9.8009 8.76297 7.49973 8.76297C5.19855 8.76297 3.33301 6.89758 3.33301 4.59641C3.33301 2.29523 5.19855 0.429688 7.49973 0.429688C9.8009 0.429688 11.6664 2.29523 11.6664 4.59641Z",
    fill: "#0C66E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9477_164095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleTabActive);
export default __webpack_public_path__ + "static/media/roleTabActive.53853f8637f93c7902cf9a4a11326fb8.svg";
export { ForwardRef as ReactComponent };